import type { ReactNode } from "react";
import useIsMobile from "~/kernel/browser/useIsMobile";

type RenderOnPhoneProps = {
  children: ReactNode;
};

export default function RenderOnPhone({ children }: RenderOnPhoneProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <>{children}</>;
  }

  return null;
}
